import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";

/** Cinematic counter — animates from 0 → target when scrolled into view.
 * Supports suffix (e.g., "+", "%", "hr") and custom duration/easing. */
export default function AnimatedCounter({ to, suffix = "", duration = 2.2, className = "", testid }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setValue(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to, duration]);

  return (
    <span ref={ref} className={className} data-testid={testid}>
      {value.toLocaleString()}{suffix}
    </span>
  );
}
